(function () {
  if (window.SorviqLP) return;

  var allowed = ['light', 'socks', 'legs', 'able'];
  var titles = {
    light: 'Feel your legs light again by evening',
    socks: 'Heavy, swollen legs without the morning fight',
    legs: 'Get your summer back from swollen ankles',
    able: 'Keep going all day on heavy, swollen legs'
  };
  var observer = null;

  function currentVersion() {
    var param = new URLSearchParams(window.location.search).get('d');
    if (allowed.indexOf(param) !== -1) return { d: param, fromUrl: true };
    var holder = document.querySelector('.sorviq-lp [data-sorviq-default]');
    var def = holder ? holder.getAttribute('data-sorviq-default') : 'light';
    return { d: allowed.indexOf(def) !== -1 ? def : 'light', fromUrl: false };
  }

  function init() {
    var v = currentVersion();
    var d = v.d;
    document.body.setAttribute('data-lp-active', d);
    // Only override the product page title when a version is forced by the ad link (?d=...).
    if (v.fromUrl) document.title = titles[d];

    // Buttons that scroll to the packs: use the direct checkout link when the page has no buy box.
    if (!document.getElementById('buybox')) {
      document.querySelectorAll('.sorviq-lp a[data-fallback-href]').forEach(function (a) {
        a.setAttribute('href', a.getAttribute('data-fallback-href'));
      });
    }

    // Pass the version to the checkout for attribution.
    document.querySelectorAll('.sorviq-lp a[href]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (!h || h.indexOf('[[') === 0 || h.charAt(0) === '#') return;
      try {
        var u = new URL(h, window.location.href);
        if (/\/cart\/\d+:\d+/.test(u.pathname)) {
          // Cart permalink: store the version as an order attribute.
          u.searchParams.set('attributes[lp_version]', d);
        } else {
          u.searchParams.set('lp_version', d);
        }
        a.setAttribute('href', u.toString());
      } catch (e) {}
    });

    // Sticky CTA shows once the hero's buy button has scrolled out of view.
    if (observer) observer.disconnect();
    var sticky = document.getElementById('sticky');
    var hero = document.getElementById('top');
    if (sticky && hero && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var past = !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle('show', past);
            sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
            var link = sticky.querySelector('a');
            if (link) link.tabIndex = past ? 0 : -1;
          });
        },
        { threshold: 0 }
      );
      observer.observe(hero);
    }
  }

  window.SorviqLP = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
